import { buildQueryParams, cleanParams } from "@/utils";

/**
 * Календарь. Модуль для работы с API
 * @module calendar
 */

/**
 * Получение списка задач на период.
 * @param {Object} params - Параметры запроса
 * @returns {Promise} - список
 * @throws {Error} - ошибка при получении данных
 */
export const getPeriodTasks = async (params) => {
  const cleanedFilters = cleanParams(params);
  const queryString = buildQueryParams(cleanedFilters);

  try {
    const response = await fetch(`/api/calendar?${queryString}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при получении данных. ${data.error || "Обновите страницу"}`
      );
    }

    return data.tasks;
  } catch (err) {
    throw err;
  }
};

/**
 * Получение ближайшего события
 * @returns {Promise} - ближайшее событие
 * @throws {Error} - ошибка при получении данных
 */
export const getNearest = async () => {
  try {
    const response = await fetch(`/api/calendar/nearest`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при получении данных. ${data.error || "Обновите страницу"}`
      );
    }

    return data;
  } catch (err) {
    throw err;
  }
};
